import {
  useState, useEffect, useCallback, useRef,
} from 'react';
import { APIGetAssetServiceSchedule } from '../../../config/restAPI/FetchAPI';
import {
  isApiResponseNotFound,
  parseApiObjectResponse,
} from './maintenanceComplianceUtils';

export function useAssetServiceSchedule(assetId, token, agencyID) {
  const [serviceSchedule, setServiceSchedule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const assetIdRef = useRef(assetId);

  useEffect(() => {
    assetIdRef.current = assetId;
  }, [assetId]);

  const refetch = useCallback(async () => {
    if (!assetId || !token || !agencyID) return;
    const requestAssetId = assetId;
    setError('');
    setLoading(true);
    try {
      const result = await APIGetAssetServiceSchedule(() => {}, token, agencyID, assetId);
      if (requestAssetId !== assetIdRef.current) return;
      if (isApiResponseNotFound(result)) {
        setServiceSchedule(null);
        return;
      }
      const data = parseApiObjectResponse(result);
      if (requestAssetId !== assetIdRef.current) return;
      if (data) {
        setServiceSchedule(data);
      } else {
        setError('Unable to load service schedule.');
      }
    } catch {
      if (requestAssetId === assetIdRef.current) {
        setError('Unable to load service schedule.');
      }
    } finally {
      if (requestAssetId === assetIdRef.current) {
        setLoading(false);
      }
    }
  }, [assetId, token, agencyID]);

  useEffect(() => {
    setServiceSchedule(null);
    setError('');
    setLoading(Boolean(assetId));
  }, [assetId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    serviceSchedule,
    loading,
    error,
    refetch,
  };
}
